import {on} from "../jsbase/events";

var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {},

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function ($rowElem) {
                var rowId = $rowElem.data('id');
                return {id: rowId, el: $rowElem, isDeleted: $rowElem.is('.inactive'), hasWriteAccess: $rowElem.is('.access-w')};
            },
            actions: [{
                name: 'Löschen',
                classNames: 'dropdown-item',
                iconClass: 'bi-trash text-danger',
                onClick: this.onDelete,
            }],
        });
    },

    events: [{
        // name: 'click',
        // el(component) {
        //     return component.el.querySelectorAll('.btn-context-click');
        // },
        // handler(ev) {
        //     ev.preventDefault();
        //     ev.stopPropagation();
        //     var rowEl = $(ev.target).closest(this.selector);
        //     this.menu.open(rowEl, ev);
        // }
        name: 'template.part-loaded',
        el() {
            return document;
        },
        handler(ev) {
            ev.detail.container.find('.btn-context-click').get().forEach((el) => {
                on(el, 'click', (cev) => {
                    var rowEl = $(cev.target).closest(this.selector);
                    this.menu.open(rowEl, cev);
                });
            });
        },
    }],

    methods: {
        onDelete(row) {
            template.deletePricePosition(row.el);
        },
    },

}
